import React from 'react';
import style from './styles.module.css';

export interface ButtonDrawerProps {
  label: string;
  icon?: React.ReactNode | React.ReactElement | JSX.Element;
  iconPosition?: 'left' | 'right' | 'top' | 'bottom';
  onClick: () => void;
  disabled?: boolean;
  isSelected?: boolean;
  variant?: 'default' | 'white' | 'transparent';
}

export const ButtonDrawer: React.FC<ButtonDrawerProps> = ({
  label,
  icon,
  iconPosition = 'left',
  onClick,
  disabled = false,
  isSelected = false,
  variant = 'default',
}) => {
  return (
    <button
      className={`
        ${style.button}
        ${isSelected ? style.selected : ''}
        ${style[`icon-${iconPosition}`]}
        ${style[`variant-${variant}`]}
      `}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && (iconPosition === 'top' || iconPosition === 'left') && (
        <span className={style.icon}>{icon}</span>
      )}
      <p className={style.label}>{label}</p>
      {icon && (iconPosition === 'bottom' || iconPosition === 'right') && (
        <span className={style.icon}>{icon}</span>
      )}
    </button>
  );
};
